export default function Legal() {
  return (
    <div className="max-w-3xl mx-auto px-5 lg:px-8 py-14 space-y-8">
      <h1 className="font-display text-3xl font-semibold text-[var(--fpn-navy)]" data-testid="legal-title">Help &amp; Policies</h1>
      <p className="text-sm text-slate-500">The pages below are placeholders. Final legal content is subject to review before public launch.</p>
      {["Terms &amp; Conditions", "Privacy Policy", "Cookie Policy", "Host Terms", "Community Parking Rules", "Cancellation Policy", "Refund Policy", "Commercial Partner Terms", "Acceptable Use Policy"].map((p, i) => (
        <section key={i} className="border-b border-slate-100 pb-6">
          <h2 className="font-display text-xl font-semibold text-[var(--fpn-navy)]" dangerouslySetInnerHTML={{ __html: p }} />
          <p className="text-sm text-slate-600 mt-2">Placeholder content. Admin will publish final policy before commercial launch.</p>
        </section>
      ))}
    </div>
  );
}
